import { defineComponent, ref, onMounted, computed, watch, } from '@vue/composition-api';
import { BTN_THEMES } from '@/store/modules/ui';
import { getUserSurveysList } from '@/api/v2/requests/surveys';
import SurveyBanner from './SurveyBanner.vue';
import SurveyModal from './SurveyModal.vue';
export default defineComponent({
    name: 'Surveys',
    components: {
        SurveyBanner,
        SurveyModal,
    },
    setup(_, ctx) {
        const isLoaded = ref(false);
        const wasModalClosed = ref(false);
        const wasBannerClosed = ref(false);
        const nodes = ref([]);
        const totalCount = ref(0);
        const isRefreshingFromSelf = ref(false);
        const refreshSurveys = async () => {
            isLoaded.value = false;
            const { nodes: surveys, totalCount: allSurveysCount } = await getUserSurveysList({
                isFulfilled: false,
            });
            nodes.value = surveys;
            totalCount.value = allSurveysCount;
            isLoaded.value = true;
        };
        onMounted(() => {
            refreshSurveys();
        });
        watch(totalCount, async (newCount) => {
            if (newCount > 0 && nodes.value.length === 0) {
                refreshSurveys();
            }
        });
        watch(() => ctx.root.$store.getters['ui/surveyRefreshTrigger'], () => {
            if (isRefreshingFromSelf.value) {
                isRefreshingFromSelf.value = false;
                return;
            }
            refreshSurveys();
        });
        const removeSurvey = (id) => {
            totalCount.value -= 1;
            nodes.value = [...nodes.value.filter(({ survey }) => survey?.id !== id)];
            isRefreshingFromSelf.value = true;
            ctx.root.$store.dispatch('ui/triggerSurveyRefresh');
        };
        const shouldDisplayBanner = computed(() => isLoaded.value &&
            wasModalClosed.value &&
            !wasBannerClosed.value &&
            totalCount.value > 0);
        return {
            nodes,
            totalCount,
            isLoaded,
            wasModalClosed,
            shouldDisplayBanner,
            wasBannerClosed,
            refreshSurveys,
            BTN_THEMES,
            removeSurvey,
        };
    },
});
